import { UnitView } from './unit.view';
import { ReasonTypeView } from './reason-type.view';

export class UserBugReportNewView {
  canSubmit: boolean;
  reasonTypes: ReasonTypeView[];
  armyId: number;
  units: UnitView[];

  constructor(params: UserBugReportNewViewParams) {
    this.canSubmit = params.canSubmit;
    this.reasonTypes = params.reasonTypes;
    this.armyId = params.armyId;
    this.units = params.units;
  }
}

export type UserBugReportNewViewParams = {
  canSubmit: boolean;
  reasonTypes: ReasonTypeView[];
  armyId: number;
  units: UnitView[];
};
